// extracted by mini-css-extract-plugin
export default {"single-element-wrapper":"jKs4Ng","singleElementWrapper":"jKs4Ng","single-element":"pgKD8G","singleElement":"pgKD8G"};